import { createSlice } from '@reduxjs/toolkit';

import { buyRole, fetchRoles } from './roles.thunk';
import type { IRole } from '../api/roles.types';
import type { ApiError } from '@/features/events/api/events.types';

interface RolesState {
  items: IRole[];
  loading: boolean;
  error: ApiError | null;
}

const initialState: RolesState = {
  items: [],
  loading: false,
  error: null,
};

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || {
          code: 500,
          message: 'Unknown error',
        };
        
      })
        .addCase(buyRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(buyRole.fulfilled, (state) => {
        state.loading = false;
  
      })
      .addCase(buyRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || {
          code: 500,
          message: 'Unknown error',
        };
      });
  },
});

export default rolesSlice.reducer;
